import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Loading from '~/components/layout/Loading';
import FilterModal from '~/components/pages/Bankslips/Filter';
import SideBar from '~/components/layout/Sidebar';
import back from '~/assets/images/arrow.svg';
import {  Redirect } from 'react-router';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { analytics, logEvent }  from "~/services/firebaseConfig";
import {
  Container,
  PageTitleContainer,
  PageIcon,
  PageTitle,
  BankSlipsContainer,
  Content,
  NextPage,
  NextPageContainer,
  PageTitleItem,
  FilterWrapper,
  FilterIcon,
  FilterText,
  HeaderMobile,
  DesktopHeaderContainer,
  WrapperBankslips,
  PageContainer,
  DesktopWrapper,
  MobileWrapper,
  HeaderIcon,
  HeaderText,
  CloseIcon,
  CloseIconContainer,
  MessageNothing,
  BankslipMessage,
  Info,
  InfoTitle,
} from './styles';
import BankslipsDesktop from '~/components/pages/Bankslips/BankslipsDesktop';
import BankslipsMobile from '~/components/pages/Bankslips/BankslipsMobile';
import ModalBankslipsDesktop from '~/components/pages/Bankslips/ModalBankslipsDesktop';
import ModalBankslipMobile from '~/components/pages/Bankslips/ModalBankslipsMobile';
import Header from '~/components/layout/Header';
import OpenChatBot from '~/components/layout/Chatbot';
import { useDispatch, useSelector } from 'react-redux';
import { verifyRoles } from '~/utils/functions/verifyRoles';
import api from '~/services/api';
import '~/components/styles/Global.css';
import pix from '~/assets/images/pix-blue.svg';

export default function Bankslips(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const economicGroupReducer = useSelector(state => state.economicGroupReducer);
  const invoiceReducer = useSelector((state) => state.invoiceReducer);

  const [bankSlips, setBankSlips] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [loadingNext, setLoadingNext] = useState(false);
  const [offset, setOffset] = useState(0);
  const [notNext, setNotNext] = useState(false);
  const [hasFilter, setHasFilter] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [openModalMobile, setOpenModalMobile] = useState(false);
  const [loading, setLoading] = useState(true);
  const roles = useSelector(state => state.rolesReducer.roles);

  useEffect(() => {
    if (!localStorage.getItem('codeStore')) {
      window.location.href = '/acessar?error';
    } else {
      localStorage.removeItem('storeInfo');
    }
  }, []);

  useEffect(() => {
    setOffset(0);
    setNotNext(false);
    setHasFilter(false);
    const storeInfoCode = localStorage.getItem('codeStore').split('-');
    const storeInfo = localStorage.getItem('storeInfo');
    if (!storeInfo) {
      localStorage.setItem('storeInfo', storeInfoCode[0]);
      setLoading(true);
      requestInvoices(storeInfoCode, true, 0, true);
    } else {
        localStorage.setItem('storeInfo', storeInfoCode[0]);
        setLoading(true);
        requestInvoices(storeInfoCode, true, 0, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [economicGroupReducer.selectedStore]);

  const requestInvoices = async (
    storeInfo,
    offsetOption,
    offsetValue,
    changeEG,
  ) => {
    const customerCode = storeInfo[0];
    const customerSiteCode = storeInfo[1];

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let beginDate = await params.get('begin-date');
    let endDate = await params.get('end-date');
    let status = await params.get('status');
    let invoiceNumber = await params.get('invoice-number');

    if (beginDate || status || invoiceNumber) {
      setHasFilter(true);
    }

    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };

    let url = `industrial/invoice/v1/installments?customer-site-code=${customerSiteCode}&customer-code=${customerCode}&_expand=invoice&_limit=20&_offset=${
      offsetOption ? offsetValue : offsetValue - 1
    }`;

    // Verificando se tem todos os filtros
    if (beginDate && endDate && status && invoiceNumber) {
      if (status !== 'TODOS') {
        url = `industrial/invoice/v1/installments?customer-site-code=${customerSiteCode}&customer-code=${customerCode}&_expand=invoice&_limit=20&invoice-number=${invoiceNumber}&begin-date=${beginDate}&end-date=${endDate}&status=${status}&_offset=${
          offsetOption ? offsetValue : offsetValue - 1
        }`;
      } else {
        url = `industrial/invoice/v1/installments?customer-site-code=${customerSiteCode}&customer-code=${customerCode}&_expand=invoice&_limit=20&invoice-number=${invoiceNumber}&begin-date=${beginDate}&end-date=${endDate}&_offset=${
          offsetOption ? offsetValue : offsetValue - 1
        }`;
      }
    }

    // Verificando se tem filtro por data apenas
    if (beginDate && endDate && status && !invoiceNumber) {
      if (status !== 'TODOS') {
        url = `industrial/invoice/v1/installments?customer-site-code=${customerSiteCode}&customer-code=${customerCode}&_expand=invoice&_limit=20&begin-date=${beginDate}&end-date=${endDate}&status=${status}&_offset=${
          offsetOption ? offsetValue : offsetValue - 1
        }`;
      } else {
        url = `industrial/invoice/v1/installments?customer-site-code=${customerSiteCode}&customer-code=${customerCode}&_expand=invoice&_limit=20&begin-date=${beginDate}&end-date=${endDate}&_offset=${
          offsetOption ? offsetValue : offsetValue - 1
        }`;
      }
    }

    // Verificando se tem filtro por invoiceNumber apenas
    if (invoiceNumber && !beginDate && !endDate && status) {
      if (status !== 'TODOS') {
        url = `industrial/invoice/v1/installments?customer-site-code=${customerSiteCode}&customer-code=${customerCode}&_expand=invoice&_limit=20&invoice-number=${invoiceNumber}&status=${status}&_offset=${
          offsetOption ? offsetValue : offsetValue - 1
        }`;
      } else {
        url = `industrial/invoice/v1/installments?customer-site-code=${customerSiteCode}&customer-code=${customerCode}&_expand=invoice&_limit=20&invoice-number=${invoiceNumber}&_offset=${
          offsetOption ? offsetValue : offsetValue - 1
        }`;
      }
    }

    // Verificando se tem filtro por status apenas
    if (!invoiceNumber && !beginDate && !endDate && status) {
      if (status !== 'TODOS') {
        url = `industrial/invoice/v1/installments?customer-site-code=${customerSiteCode}&customer-code=${customerCode}&_expand=invoice&_limit=20&status=${status}&_offset=${
          offsetOption ? offsetValue : offsetValue - 1
        }`;
      } else {
        url = `industrial/invoice/v1/installments?customer-site-code=${customerSiteCode}&customer-code=${customerCode}&_expand=invoice&_limit=20&_offset=${
          offsetOption ? offsetValue : offsetValue - 1
        }`;
      }
    }

    api
      .get(url, parameters)
      .then(res => {
        setLoadingNext(false);
        if (res.status === 200) {
          let bankSlipsArray = bankSlips;
          if (!changeEG) {
              res.data.map(bankslip => {
               bankSlipsArray.push(bankslip);
               return;
            });
          } else {
            bankSlipsArray = res.data;
          }
          if (res.data?.length < 20) {
            setNotNext(true);
          }
          dispatch({ type: "SET_BANKSLIPS", bankSlips: bankSlipsArray })
          setBankSlips(bankSlipsArray);
        }
        setLoading(false);
      })
      .catch(err => {
        setLoadingNext(false);
        setLoading(false);
        const erro = err.response;
        if (erro) {
          if (err.response.status !== 401) {
            if (err.response?.data[0]?.message) {
              if (
                err.response?.data[0]?.message ===
                'O campo end-date tem o formato inválido.'
              ) {
                toast.error('Data final inválida');
              } else if (
                err.response?.data[0]?.message ===
                'O campo begin-date tem o formato inválido.'
              ) {
                toast.error('Data inicial inválida');
              } else {
                toast.error(err.response?.data[0]?.message);
              }
            }
          }
        }
      });
  };

  const handleOpenFilter = () => {
    setFilterModal(!filterModal);
  };

  function handleOpenModal(bankSlip) {
    dispatch({
      type: 'invoice/GET_MODAL_INFORMATION',
      modalInformation: bankSlip,
    });
    setOpenModal(!openModal);
  }

  function handleOpenModalMobile(bankSlip) {
    dispatch({
      type: 'invoice/GET_MODAL_INFORMATION',
      modalInformation: bankSlip,
    });
    setOpenModalMobile(!openModalMobile);
  }

  const nextPage = () => {
    logEvent(analytics, 'carregar_mais_boletos');
    const storeInfo = localStorage.getItem('codeStore').split('-');
    requestInvoices(storeInfo, true, offset + 1, false);
    setOffset(offset + 1);
    setLoadingNext(true);
  };

  return (
    <PageContainer>
      {verifyRoles(roles, 'BOLETOS') ? (
        <>
          {openModal ? (
            <ModalBankslipsDesktop close={() => setOpenModal(!openModal)} />
          ) : openModalMobile ? (
            <ModalBankslipMobile
              close={() => setOpenModalMobile(!openModalMobile)}
            />
          ) : (
            <SideBar menuSelected={'Minha Conta'} disabledOnMobile>
              <Container>
                <DesktopHeaderContainer>
                  <Header disabledOnMobile />
                </DesktopHeaderContainer>
                <Content>
                  <HeaderMobile>
                    <HeaderIcon className="mdi mdi-store mr-2" />
                    <HeaderText>{localStorage.getItem('storeName')}</HeaderText>
                  </HeaderMobile>
                  <WrapperBankslips>
                    <CloseIconContainer>
                      <CloseIcon>
                        <img
                          src={back}
                          alt="Ícone para voltar"
                          onClick={() => history.push('/minha-conta')}
                        />
                      </CloseIcon>
                    </CloseIconContainer>
                    <Info>
                    <InfoTitle>
                      Realize o pagamento via PIX, clicando no símbolo <img src={pix} alt="Debito no pedido" /> <br/>
                      A chave PIX será copiada, e você deverá utilizá-la para concluir o pagamento no aplicativo do seu banco. <br/>
                      Ao finalizar, o seu pagamento será identificado automaticamente.
                    </InfoTitle>
                  </Info>
                    <PageTitleContainer>
                      <PageTitleItem>
                        <PageIcon className="mdi mdi-barcode mr-2" />
                        <PageTitle>Boletos</PageTitle>
                      </PageTitleItem>
                      <div className="d-flex flex-row align-items-center">
                        {hasFilter ? (
                          <FilterWrapper
                            className="mr-3"
                            onClick={() => (window.location = '/boletos')}
                          >
                            <FilterIcon src="./assets/images/clear.png" />
                            <FilterText>Limpar filtros</FilterText>
                          </FilterWrapper>
                        ) : null}
                        <FilterWrapper onClick={() => handleOpenFilter()}>
                          <FilterIcon src="./assets/images/filter.svg" />
                          <FilterText>Filtrar</FilterText>
                        </FilterWrapper>
                      </div>
                    </PageTitleContainer>
                    {loading ? (
                      <Loading />
                    ) : (
                      <>
                        {invoiceReducer?.bankSlips?.length < 1 ? (
                          <BankslipMessage>
                            <span>Nenhum boleto encontrado</span>
                          </BankslipMessage>
                        ) : (
                          <BankSlipsContainer>
                            <DesktopWrapper>
                              {invoiceReducer?.bankSlips?.map((bankSlip, index) => {
                                return (
                                  <BankslipsDesktop
                                    data={bankSlip}
                                    key={index}
                                    openModal={() => handleOpenModal(bankSlip)}
                                  />
                                );
                              })}
                            </DesktopWrapper>
                            <MobileWrapper>
                              {invoiceReducer?.bankSlips?.map((bankSlip, index) => (
                                <BankslipsMobile
                                  data={bankSlip}
                                  key={index}
                                  openModal={() =>
                                    handleOpenModalMobile(bankSlip)
                                  }
                                />
                              ))}
                            </MobileWrapper>
                            {hasFilter && invoiceReducer?.bankSlips?.length === 0 && notNext && (
                              <MessageNothing>
                                Nenhum resultado encontrado
                              </MessageNothing>
                            )}
                            <NextPageContainer content="center">
                              {notNext ? null : (
                                <NextPage onClick={() => nextPage()}>
                                  {loadingNext ? (
                                    <i
                                      className="fa fa-spinner fa-pulse fa-3x fa-fw"
                                      style={{
                                        fontSize: '16px',
                                        color: '#000FFF',
                                      }}
                                    />
                                  ) : (
                                    'Carregar mais...'
                                  )}
                                </NextPage>
                              )}
                            </NextPageContainer>
                          </BankSlipsContainer>
                        )}
                      </>
                    )}
                  </WrapperBankslips>
                </Content>
                <Modal
                  animation={false}
                  show={filterModal}
                  onHide={() => {
                    handleOpenFilter();
                  }}
                  className="modal-vale-gas"
                  centered={window.screen.width >= 768}
                >
                  <FilterModal close={() => handleOpenFilter()} />
                </Modal>
              </Container>
              <OpenChatBot />
            </SideBar>
          )}
        </>
      ) : (
        <Redirect to="/portal" />
      )}
    </PageContainer>
  );
}
